<template>
    <div id="app">
        <main-header nowtab="play"></main-header>
        <main class="adjuster">
            <a-card size="small" class="card dashboard-card">
                <a-row :gutter="8">
                    <a-col>
                        <a-select
                            show-search
                            :show-arrow="false"
                            style="width: 200px"
                            v-model="tower"
                            :options="options"
                            optionFilterProp="label"
                            :filter-option="filterOption"
                            @search="toggleSelection"
                            @change="search()"
                            :open="open"
                        />
                        <a-input-search
                            style="width: 320px"
                            v-model="searchstr"
                            placeholder="查找用户名/分数"
                            enter-button @search="search()"
                        />
                    </a-col>
                </a-row>
            </a-card>
            <a-card size="small" class="card submission-card">
                <router-view />
            </a-card>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import axios from 'axios';
import Result from './Result.vue';

export default {
    data: () => ({
        searchstr: "",
        tower: "",
        towers: [],
        open: false,
    }),
    computed: {
        options() {
            return [{ key: "", label: "全部塔" }].concat(
                this.towers.map(({ name, title }) => {
                    return { key: name, label: title };
                })
            )
        },
    },
    async created() {
        this.searchstr = this.$route.query.q;
        this.tower = this.$route.query.tower;
        const { data } = await axios
            .get("/backend/towers/query.php", {
                params: {
                    mode: 'list'
                }
            });
        this.towers = data.list.reverse();
    },
    methods: {
        search() {
            this.open = false;
            this.$router.push({
                query: {
                    q: this.searchstr, p: 1, tower: this.tower
                }
            });
        },
        filterOption(input, option) {
            if (input === "") return false;
            return (
                option.componentOptions.children[0].text.includes(input)
            );
        },
        toggleSelection(value) {
            if (value === "") this.open = false;
            else this.open = true;
        }
    },
    components: {
        MainHeader, Footer,
        Result,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    width: 100%;
    @media screen and (min-width: 1000px) {
        margin: 20px auto;
    }
    @media screen and (max-width: 999px) {
        margin: 0 auto;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.dashboard-card {
    transition: none;
    @media screen and (min-width: 560px) {
        width: 560px;
    }
    @media screen and (max-width: 559px) {
        width: 100%;
        margin-top: 0;
    }
}
.submission-card {
    transition: none;
    @media screen and (min-width: 1000px) {
        width: 98%;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
</style>
